import PersonAddIcon from "@mui/icons-material/PersonAdd";
import React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { AppToolButton } from "ui/Scripts/source/components/framework/Button/AppToolButton";
import { IconButtonProps } from "@mui/material";

interface IAddUserToolButtonProps extends IconButtonProps {
    tooltip?: string
}

export const AddUserToolButton = (props: IAddUserToolButtonProps) => (
    <AppToolButton
        {...props}
        tooltip={props.tooltip ?? Translations.AddUser}
        icon={<PersonAddIcon />}
    />
);
